import * as React from "react";
import { Link as GatsbyLink } from "gatsby";
import PropTypes from "prop-types";

function BaseLink(props) {
  const {
    id,
    componentName,
    className,
    children,
    url,
    external = false,
    download = false,
    wistia,
    style,
  } = props;

  if (wistia !== undefined) {
    return (
      <a
        id={id}
        data-component-name={componentName}
        className={className}
        href="#"
        download
        style={style}
        onClick={(e) => {
          e.preventDefault();
          window.Wistia.api(wistia).play();
        }}
      >
        {children}
      </a>
    );
  } else if (download) {
    return (
      <a
        id={id}
        data-component-name={componentName}
        className={className}
        href={url}
        download
        style={style}
      >
        {children}
      </a>
    );
  } else if (external) {
    return (
      <a
        id={id}
        data-component-name={componentName}
        className={className}
        href={url}
        rel="opener"
        target="_blank"
        style={style}
      >
        {children}
      </a>
    );
  } else {
    return (
      <GatsbyLink
        id={id}
        data-component-name={componentName}
        className={className}
        to={url}
        style={style}
      >
        {children}
      </GatsbyLink>
    );
  }
}

BaseLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  url: PropTypes.string,
  external: PropTypes.bool,
  download: PropTypes.bool,
};

export default BaseLink;
